/* eslint-disable no-unused-vars */
export const INTEG_CLIENT = 'INTEG'
export const DUCK_CLIENT = 'DUKE'
export const DUKE_FHO = 'DUKE_FHO'
export const WEE_CLIENT = 'WEE'
export const AEPREG_CLIENT = 'AEPREG'
export const AEPUNREG_CLIENT = 'AEPUNREG'
export const DOM_CLIENT = 'DOM' // for dominion
export const KINDLE_CLIENT = 'KINDLE'
export const EAST_GEN_CLIENT = 'ESTGEN' // this is aquired by Kindle
export const CPS_CLIENT = 'CPS'
export const CALPLINE_CLIENT = 'CALP'
export const PSE_CLIENT = 'PSE'
export const BROOKFIELD_CLIENT = 'BKF'
export const SRP_CLIENT = 'SRP'
export const APS_CLIENT = 'APS'
export const PJM_CLIENT = 'PJM'
export const NE_NEW_ENGLAND = 'NEG'
export const MISO_CLIENT = 'MISO'
export const TALEN_CLIENT = 'TALEN'
export const CLECO = 'CLECO'
export const FE = 'FE'
export const GENON = 'GENON'
export const PSE = 'PSE'
export const ESTKEN = 'ESTKEN' // Eastern Kentucky
export const PSEG = 'PSEG'
export const ENGHAR = 'ENGHAR' // Energy Harbor
export const NRG_CLIENT = 'NRG'
export const GENON_CLIENT = 'GENON'
export const LANYARD_CLIENT = 'LANYARD'
export const NYISO_CLIENT = 'NYISO'
export const TOTALENGERY_CLIENT = 'TOTENG'
export const TVA_CLIENT = 'TVA'
export const BEPC_CLIENT = 'BEPC'
export const COOP_CLIENT = 'COOP'
export const NVENERGY = 'NEVADA'
/*
card-data/getServiceUtil.js
piwind/pimonsummary/clientwise.js
*/
